import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const Hero = ({ setShowBooking }) => {
  return (
    <section
      className="relative min-h-screen flex items-center pt-72"
      style={{
        background: `linear-gradient(to right, rgba(15, 23, 42, 0.6), rgba(15, 23, 42, 0.3), transparent), url('https://images.unsplash.com/photo-1665249934445-1de680641f50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBjbGVhbiUyMGxpdmluZyUyMHJvb20lMjBzdW5saXR8ZW58MHx8fHwxNzc2NjQ5MjY2fDA&ixlib=rb-4.1.0&q=85')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="container mx-auto px-8 py-24">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span
                className="text-xs font-bold tracking-[0.2em] uppercase"
                style={{ color: '#7DD3FC' }}
              >
                YOUR SPACE, OUR CARE
              </span>
            </div>

            <h1
              className="text-5xl sm:text-6xl tracking-tighter font-light mb-6"
              style={{ fontFamily: 'Outfit', color: '#FFFFFF' }}
            >
              Where Your Space Gets the Royal Treatment
            </h1>

            <p
              className="text-base leading-relaxed mb-12 max-w-xl"
              style={{ color: 'rgba(255, 255, 255, 0.9)' }}
            >
              Fully insured and trusted by Georgia's businesses and families since 2024. 
              We're not just cleaning; we're creating comfort, safety, and satisfaction in every corner.
            </p>

            <div className="flex flex-wrap gap-4">
              <button
                data-testid="hero-book-now-btn"
                onClick={() => {
                  document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-4 rounded-full font-medium text-lg hover:opacity-90 transition-opacity flex items-center gap-2"
                style={{ background: '#0284C7', color: '#FFFFFF' }}
              >
                <Sparkles className="w-5 h-5" />
                Book Now
              </button>

              <button
                data-testid="hero-get-estimate-btn"
                onClick={() => {
                  document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-4 rounded-full font-medium text-lg glassmorphism hover:opacity-90 transition-opacity"
                style={{ color: '#0F172A' }}
              >
                Get Estimate
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;